export enum CategoryType {
  CHARGE = 'Charge',
  GENERAL = 'General',
  TRANSACTIONS_PAYMENT = 'Transactions - Payments',
  TRANSACTIONS_PAYMENT_DETAIL = 'Transactions - Payment Detail',
  TRANSACTIONS_CHARGEBACK_DETAIL = 'Transactions - Chargeback Detail',
  PAYMENT_LINK = 'Payment Links',
  PAYMENT_LINK_DETAIL = 'Payment Link Detail',
  PAYMENT_LINK_SUCCESS = 'Payment Link Success',
  FIANCE_INVOICE_DETAIL = 'Finance - Invoice Detail',
  FIANCE_ACCOUNT_STATEMENT = 'Finance - Account Statement',
  SUBSCRIPTIONS_CUSTOMER = 'Subscription - Customers',
  SUBSCRIPTIONS_CUSTOMER_DETAIL = 'Subscription - Customer Detail',
  SUBSCRIPTIONS_PLANS = 'Subscription - Plans',
  DEVELOPERS = 'Developers',
  MY_BUSINESS = 'My Business',
  MY_BUSINESS_USERS = 'My Business - Users',
  MY_BUSINESS_SECURITY = 'My Business - Security',
  DASHBOARD_SALES = 'Dashboard - Sales',
  DASHBOARD_ACCEPTANCE = 'Dashboard - Acceptance',
  ONBOARDING = 'Onboarding',
  WELCOME_SCREEN = 'Welcome Screen',
  COMPANY_DRAFT = 'Company Draft',
  QR_CODE = 'QR Code'
}

export enum ActionType {
  DOWNLOAD_REPORT_LINK = 'Download Report Link',
  DUPLICATE_LINK = 'Duplicate Link',
  FILTER = 'Filter',
  FILTER_STATUS_LINK = 'Filter Status Link',
  QUALIFY_CHARGE = 'Qualify charge'
}

export enum Label {
  DUPLICATE_LINK = 'payment_link_duplicate'
}

export const createEvent = (action: string, category: string, label: string, data?: any): void => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: data
    })
  }
}
